<template>
  <b-container fluid>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col cols="12">
        <h5>Recibos</h5>
        <b-table
            id="recibos"
            thead-tr-class="columnas"
            :items="items"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos"
            fixed
        >
          <template v-slot:cell(montopagado)="row">
            {{ row.item.montopagado | moneda }}
          </template>
          <template v-slot:cell(saldo)="row">
            {{ row.item.saldo | moneda }}
          </template>
          <template v-slot:cell(aplicacion)="row">
            {{ row.item.aplicacion | moneda }}
          </template>
          <template v-slot:cell(tipoRecibo)="row">
            <b-badge v-if="row.item.tipoRecibo === 1" variant="primary"
            >PTI
            </b-badge
            >
            <b-badge v-else-if="row.item.tipoRecibo === 3" variant="primary"
            >Movimiento Saldo
            </b-badge
            >
            <b-badge v-else-if="row.item.tipoRecibo === 4" variant="primary"
            >Traspaso Saldo
            </b-badge
            >

            <b-badge v-else variant="secondary">Sesión</b-badge>
          </template>
          <template v-slot:cell(Estatus)="row">
            <b-badge v-if="row.item.activo" variant="success">Activo</b-badge>
            <b-badge v-else variant="danger">Cancelado</b-badge>
          </template>
          <template v-slot:cell(Acciones)="row">
            <b-button-group v-if="row.item.activo">
<!--              <b-button
                  title="Ver"
                  size="sm"
                  @click="detalle(row.item)"
                  variant="outline-primary"
                  :disabled="row.item.loaderRecibo"
              ><em v-if="!row.item.loaderRecibo" class="fa fa-eye"></em>
                <b-spinner small v-else label="Spinning"></b-spinner>
              </b-button>-->
              <b-button v-b-modal="'mostrar-archivo-imagen-'+row.item.idRecibo"
                        @click="obtenerRecibo(row.item)"
                        variant="outline-primary" size="sm">
                <font-awesome-icon icon="eye"/>
              </b-button>
              <b-modal
                  ok-title="Aceptar"
                  cancel-title="Cerrar"
                  size="xl"
                  :id="'mostrar-archivo-imagen-'+row.item.idRecibo" title="Recibo">
                <p class="my-4">
                  <MostrarArchivoPdfOImagen :archivo="archivoPdf" :desdeRecibo="desdeRecibo" ></MostrarArchivoPdfOImagen>
                </p>
              </b-modal>

            </b-button-group>
          </template>
          <template v-slot:cell(fecha)="row">
            {{ row.item.fecha | formatoFechaHora }}
          </template>
          <template v-slot:cell(idRecibo)="row">
            {{
              row.item.numeroRecibo !== null
                  ? row.item.numeroRecibo
                  : row.item.idRecibo
            }}
          </template>
        </b-table>
        <div align="center" v-if="loaderRecibo">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-if="!loaderRecibo">
          <b-alert v-if="items.length === 0" variant="warning" show
          >No hay datos
          </b-alert
          >
        </b-col>
        <b-col v-if="!loaderRecibo">
          <b-pagination
              v-if="
                items !== undefined && items.length > 15
              "
              align="center"
              v-model="paginaActual"
              :total-rows="items.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
          ></b-pagination>
        </b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>


import {FiscalesService} from "@/apiServices/fiscales/FiscalesService";
import {ReportesService} from "@/apiServices/reportes/ReportesService";
import MostrarArchivoPdfOImagen from "@/components/archivos/MostrarArchivoPdfOImagen";

export default {
  name: "ListaRecibosPorPaciente",
  components: {MostrarArchivoPdfOImagen},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    loaderRecibo: false,
    desdeRecibo: true ,
    paciente: null,
    items: [],
    fields: [
      {key: "fecha", label: "Fecha", sortable: true},
      {key: "clinica", label: "Clinica", sortable: true},
      {key: "montopagado", label: "Pago", sortable: true},
      {key: "aplicacion", label: "Aplicacion de saldo", sortable: true},
      {key: "saldo", label: "Saldo", sortable: true},
      {key: "idRecibo", label: "Recibo", sortable: true},
      {key: "tipoRecibo", label: "Tipo", sortable: true},
      "Estatus",
      "Acciones",
    ],
    registrosPorPagina: 15,
    paginaActual: 1,
    fiscalesService: new FiscalesService(),
    reportesService: new ReportesService(),
    archivoPdf: {
      ext: "pdf",
      mime: "application/pdf",
      base64: null,
    },

  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.$root.$on('paciente', (paciente) => {
      this.loaderRecibo = true;
      this.paciente = paciente;
      this.fiscalesService.obtenerRecibosPagadosPorPaciente(paciente.idPaciente).then(recibos => {
        this.items = recibos;
        this.loaderRecibo = false;
      });
    })
  },
  methods: {
    obtenerRecibo(item){
      item.loaderRecibo = true;
      const envio = {
        idRecibo: item.idRecibo,
        horas: this.$horas()
      }
      if (item.tipoRecibo === 2) {
        this.reportesService.obtenerReciboPDF(envio).then(archivo => {
          this.archivoPdf.base64 = archivo;
        });
      }
    }
  }
}
</script>

<style scoped>

</style>
